// enum specificato a DB, valori possibili per la gestione automatica dei file
export const FILE_AUTO_DELETE_VALUES = {
    NEVER: 'NEVER',
    AUTO45DAYS: 'AUTO45DAYS',
    DONOTSAVE: 'DONOTSAVE',
};
